export default "_next/static/rdkit.d7e8c69f2e1391f4a9b818ec44b4b458.wasm";